import { Component, OnInit } from '@angular/core';
import { ViewEncapsulation } from '@angular/core';

import { DatabaseService, AutoSubOnDestroy } from '../../providers';
import { GroupStatus } from '../../models/progress-model';
import { OfflineService } from '../offline.service';

@AutoSubOnDestroy()
@Component({
    selector: 'offline-switch',
    templateUrl: './offline-switch.component.html',
    styleUrls: ['./offline-switch.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class OfflineSwitchComponent implements OnInit {
    public cacheStatus: GroupStatus = 'Cached';

    constructor(private db: DatabaseService, public offlineService: OfflineService) {
    }

    ngOnInit() {
    }

    public async requestOfflineMode(enable: boolean) {
        //await this.offlineService.awaitInit();
        this.offlineService.enableOfflineMode(enable);
    }
}
